// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hp","advertCardHeader__actions":"c-a_hq","advertCardHeader__bottomLabel":"c-a_hr"};